'use client'
import { Box, Group, Skeleton } from '@mantine/core'
import { useTranslations } from 'next-intl'
import React, { Suspense } from 'react'

import { SectionErrorBoundary } from '@/components/error/boundary'
import Swiper from '@/components/Swiper'
import type { CoinCategoriesResponse } from '@/services/category'

import CategoryCard from './CategoryCard'

function CategoryFallback() {
  return (
    <Box p={16}>
      <Skeleton
        height={32}
        w={160}
        radius="xl"
        mb="sm"
        style={{ backgroundColor: 'var(--bg-surface-secondary)' }}
      />
      <Group gap="md" wrap="nowrap">
        {[0, 1, 2, 3].map(index => (
          <Skeleton
            key={index}
            h={{ base: 270, md: 274 }}
            w={{ base: 253, md: 230, lg: 302 }}
            miw={{ base: 253, md: 230, lg: 302 }}
            style={{
              backgroundColor: 'var(--bg-surface-secondary)',
              flexShrink: 0,
              borderRadius: 32,
            }}
          />
        ))}
      </Group>
    </Box>
  )
}

interface FeaturedCategoriesProps {
  coinCategoriesData: CoinCategoriesResponse
}

function FeaturedCategories({ coinCategoriesData }: FeaturedCategoriesProps) {
  const t = useTranslations('category')

  const categorySwiperList = coinCategoriesData?.categories?.slice(0, 4)

  if (!categorySwiperList || categorySwiperList.length === 0) return null

  return (
    <Suspense fallback={<CategoryFallback />}>
      <Swiper
        title={t('featuredCategories')}
        swiperList={categorySwiperList}
        renderSwiper={(item, idx) => <CategoryCard key={idx} data={item} />}
      />
    </Suspense>
  )
}

export default SectionErrorBoundary.with(FeaturedCategories)
